import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import COLORS from '@mlb/react-patterns/style/universal.color';

export const Header = styled.h4`
    margin-bottom: 12px;
    font-family: ${({ theme }) => theme.fonts?.family?.primary};
    font-size: 16px;
    font-weight: bold;
    color: ${({ theme, disabled }) => disabled ? COLORS.mlbGrey5 : theme.filter?.filterHeaderColor};
`;

const FilterHeader = (props) => {

    const {
        text,
        className,
        disabled,
    } = props;

    if (!text) {

        return null;

    }

    return (
        <Header className={className} disabled={disabled}>{text}</Header>
    );

};

FilterHeader.propTypes = {
    text: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
};

FilterHeader.defaultProps = {
    text: undefined,
    className: undefined,
    disabled: undefined,
};

export default FilterHeader;
